import { useNavigate } from "react-router-dom";
import { useSession } from "../../../context/SessionContext";
import { useCallback, useEffect, useState } from "react";
import { GET_INMUEBLES_BY_USER } from "../../../api/apiInmuebles";
import Folder from "../../atoms/Folder";
import { PropagateLoader } from "react-spinners";

const UserDashboard = () => {
    const navigate = useNavigate();
    const { user } = useSession();
    const [loading, setLoading] = useState();
    const [inmuebles, setInmuebles] = useState();

    const getInmuebles = useCallback ( async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const inmueblesData = await GET_INMUEBLES_BY_USER(id);
            setInmuebles(inmueblesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (user?.id && user?.role === "Resident") {
            getInmuebles(user.id);
        }
    }, [user?.id, user?.role, getInmuebles]);

    if (loading) return <div className="h-full w-full flex justify-center items-center"> <PropagateLoader color="red" /> </div>;

    return (
        <div className="grid grid-cols-2 gap-4">
            {inmuebles?.map((inm) =>(
                <Folder
                    key={inm.id}
                    onClick={()=>navigate(`/${user?.id}/${inm?.id}`)}
                    children={<h2 className="text-2xl text-white font-bold h-full flex items-center justify-center"> {inm.name} </h2>}
                />
            ))}
        </div>
    );
};

export default UserDashboard;